import { useState } from "react";
import { Col, Row, ProgressBar,Modal, Button } from "react-bootstrap";
import '../style/scss/topbar.scss';

import Certik from '../style/images/topbar/certik.svg';
import ModalCloseBtn from '../style/images/topbar/closebtn.svg';
import BgModal from '../style/images/section.png'

const TopBar = () => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

            // <Modal show={showModal} onHide={handleClose} centered dialogClassName="certikmodal" size="xl">
                
            //     {/* <Modal.Header closeButton>
            //         <div className="modalmain" closeButton>
            //             <div className="modalbg">
            //                 <div className="content">
            //                     <Row>
            //                         <div className="bigTitle">$HULK Public Sale is live on Pinksale</div>
            //                         <div className="smallTitle">12:00PM UTC, January 9th - 12th</div>
            //                     </Row>
            //                 </div>
            //             </div>

            //             <Col className="parentTime">
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">02</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">12</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">16</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">54</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //             </Col>

            //             <Col className="datepane">
            //                 <div>Days</div>
            //                 <div>Hours</div>
            //                 <div>Minutes</div>
            //                 <div>Seconds</div>
            //             </Col>

            //             <Col className="etherpane">
            //                 <div>66.063773…</div>
            //                 <div>/350 ETH SOLD</div>
            //             </Col>

            //             <div className="modalprogressbar">
            //                 <ProgressBar variant="success" now={40}></ProgressBar>
            //             </div>

            //             <div className="modalbtn">
            //                 <Button className="btn-pinksale">Buy on PinkSale</Button>
            //                 <Button className="btn-certik">Certik</Button>
            //             </div>



            //         </div>
            //     </Modal.Header> */}
            //     <Modal.Body >
            //         <div className="modalmain">qweqwe
            //             {/* <div className="modalbg">
            //                 <div className="content">
            //                     <Row>
            //                         <div className="bigTitle">$HULK Public Sale is live on Pinksale</div>
            //                         <div className="smallTitle">12:00PM UTC, January 9th - 12th</div>
            //                     </Row>
            //                 </div>
            //             </div>

            //             <Col className="parentTime">
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">02</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">12</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">16</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //                 <div className="interpane">:</div>
            //                 <div className="timepane">
            //                     <div className="divpane">
            //                         <div className="bgpane">
            //                             <div className="timefont">54</div>
            //                         </div>
            //                     </div>
            //                 </div>
            //             </Col>

            //             <Col className="datepane">
            //                 <div>Days</div>
            //                 <div>Hours</div>
            //                 <div>Minutes</div>
            //                 <div>Seconds</div>
            //             </Col>

            //             <Col className="etherpane">
            //                 <div>66.063773…</div>
            //                 <div>/350 ETH SOLD</div>
            //             </Col>

            //             <div className="modalprogressbar">
            //                 <ProgressBar variant="success" now={40}></ProgressBar>
            //             </div>

            //             <div className="modalbtn">
            //                 <Button className="btn-pinksale">Buy on PinkSale</Button>
            //                 <Button className="btn-certik">Certik</Button>
            //             </div> */}
            //         </div>
            //     </Modal.Body>
            // </Modal>
    return (
        <div id="TopBar">
            <Modal show={showModal} onHide={handleClose} backdrop='static' centered dialogClassName="certikmodal">
                <div className="modalmain">
                    <div className="modalbg">
                        <div className="content">
                            <div>
                                <div className="bigTitle">$HULK Public Sale is live on Pinksale</div>
                                <div className="smallTitle">12:00PM UTC, January 9th - 12th</div>
                            </div>
                            <div className="closebtn">
                                <img src={ModalCloseBtn} alt="modalclose"  onClick={handleClose}/>     
                            </div>
                        </div>
                        <Col className="parentTime">
                            <div className="bgpane">
                                <div className="timefont">02</div>
                            </div>
                            <div className="interpane">:</div>
                            <div className="bgpane">
                                <div className="timefont">12</div>
                            </div>
                            <div className="interpane">:</div>
                            <div className="bgpane">
                                <div className="timefont">16</div>
                            </div>
                            <div className="interpane">:</div>
                            <div className="bgpane">
                                <div className="timefont">54</div>
                            </div>
                        </Col>

                        <Col className="datepane">
                            <div>Days</div>
                            <div>Hours</div>
                            <div>Minutes</div>
                            <div>Seconds</div>
                        </Col>

                        <Col className="etherpane">
                            <div>66.063773…</div>
                            <div>/350 ETH SOLD</div>
                        </Col>

                        <div className="modalprogressbar">
                            <ProgressBar variant="success" now={22}></ProgressBar>
                        </div>

                        <div className="modalbtn">
                            <Button className="btn-pinksale">Buy on PinkSale</Button>
                            <Button className="btn-certik">Certik</Button>
                        </div>
                    </div>
                </div>
            </Modal>

            <div className="topbar" onClick={() => handleShow()}>
            {/* <div className="topbar" > */}
                <div className='topdata'>
                    <span>Hulk Token</span> Round <span>1</span> is live
                </div>
                
                <Row className='notifyitem'>
                    <Col className='gridroot'>
                        <Col className="counteritem">
                            <div className="headtitle">0</div>
                            <div className="headdescript">DAYS</div>
                        </Col>
                        <Col className="counteritem">
                            <div className="headtitle">0</div>
                            <div className="headdescript">HOURS</div>
                        </Col>
                        <Col className="counteritem">
                            <div className="headtitle">0</div>
                            <div className="headdescript">MINUTES</div>
                        </Col>
                        <Col className="counteritem">
                            <div className="headtitle">0</div>
                            <div className="headdescript">SECONDS</div>
                        </Col>
                        
                    </Col>

                    <div className='notilink'>
                        <img src={Certik} alt="" width="111" height="33" />
                    </div>
                </Row>

                <Col className='coins '>
                    <Col className="coinstop">
                        <div><span>2100</span> SOL</div>
                        <div><span>5200</span> SOL</div>
                    </Col>
                    <div className="coinsprogressbar">
                        <ProgressBar variant="success" now={40} ></ProgressBar>
                    </div>
                    <Col className="coinsbottom">
                        <div>Softcap</div>
                        <div>Hardcap</div>                        
                    </Col>
                </Col>
            </div>            
        </div>
    )

}

export default TopBar;